import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ma-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: [
          { title: '発達記録', href: '/child-development', color: 'primary' },
          { title: `${_ctx.className} (${_ctx.year}年度)` },
        ]
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_page_title, {
      value: `発達記録 - ${_ctx.className} (${_ctx.year}年度)`
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_table, null, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "text-left" }, " 園児名 "),
              _createElementVNode("th", { class: "text-left" }, " 年齢 "),
              _createElementVNode("th", { class: "text-left" }, " 発達記録 "),
              _createElementVNode("th", { class: "text-left" }, " 経過記録 ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (c, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(`${c.lastName} ${c.firstName}`), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.getAgeBasedonBirthdate(c.dateOfBirth)), 1),
                _createElementVNode("td", null, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "outlined",
                    to: `/child-development/child/${_ctx.year}/${c.childId}`
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode(" 編集 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "outlined",
                    to: `/child-development/progress/${_ctx.year}/${c.childId}`
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode(" 編集 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}